import { jdiColorFetch } from "../colorFetchV2";
import {
    FeedbackGetListRequest,
    FeedbackGetListResponse,
    FeedbackCheckRequest,
    FeedbackCheckResponse
} from "./feedback.interface";

//用户反馈-获取subject列表
export const fetchFeedbackGetList = async (requestData: FeedbackGetListRequest): Promise<FeedbackGetListResponse> => {
  const res = await jdiColorFetch(`user_feedback_getList`, {
    method: "get",
    bodyQuery: requestData
  });
  return res;
};

//用户反馈关闭记录及校验（仅搜索&推荐场景）
export const fetchFeedbackCheck = async (requestData: FeedbackCheckRequest): Promise<FeedbackCheckResponse> => {
  const res = await jdiColorFetch(`user_feedback_check`, {
    method: "post",
    bodyQuery: requestData
  });
  return res;
};

//用户反馈-提交反馈结果
export const fetchFeedbackSubmit = async (requestData: any): Promise<FeedbackCheckResponse> => {
  const res = await jdiColorFetch(`user_feedback_add`, {
    method: "post",
    bodyQuery: requestData,
  });
  return res;
};
